/// <reference path="../../../../typings/tsd.d.ts" />
module warsApp.models {

    export class ProcessFormsConfigurationModel {
        private logType: string = "ProcessFormsConfigurationModel";

        public process = {};
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public forms: Wars.Domain.Model.Form[];
        public search: any;

        constructor(
            private id: string,
            private processConfigurationService: services.ProcessConfigurationService,
            private formService: services.FormService,
            private locationService: angular.ILocationService,
            private dataSourceService: services.DataSourceService,
            private securityMatrixService: services.SecurityMatrixService,
            private deleteService: services.DeleteService,
            private modalService: any)
        {
            var self = this;
            if (id) {
                this.processConfigurationService.getProcessConfigurationWithForms(id)
                    .then(
                        (processConfig) => {
                            self.processConfiguration = processConfig;
                            self.forms = processConfig.myForms;
                    });
            } else {
                this.formService.getSystemForms()
                    .then(forms => {
                        this.forms = forms;
                    });
            }

            this.search = {
                name: ''
            }
        }

        public orderDown(form: Wars.Domain.Model.Form) {
            const newPosition = form.displayOrder + 1;

            var oldForm = Enumerable.from(this.forms).firstOrDefault(c => c.displayOrder == newPosition);

            if (oldForm) {
                oldForm.displayOrder--;
                form.displayOrder++;
            }

            this.save();
        }

        public orderUp(form: Wars.Domain.Model.Form) {
            const newPosition = form.displayOrder - 1;

            var oldForm = Enumerable.from(this.forms).firstOrDefault(c => c.displayOrder == newPosition);

            if (oldForm) {
                oldForm.displayOrder++;
                form.displayOrder--;
            }

            this.save();
        }

        public fixFormOrder() : void {
            var formCount = this.forms.length;
            var orderedForms = Enumerable.from(this.forms).orderBy(i => i.displayOrder).toArray();
            for (let i = 0; i < formCount; i++) {
                orderedForms[i].displayOrder = (i + 1);
            }
            this.save();
        }

        public addForm() {
            var newForm = this.formService.createForm(this.processConfiguration);
            if (this.processConfiguration.myProcessType.isReportProcess) {
                newForm.formType = Wars.Domain.Model.Codes.Enums.FormType.Report;
            } else {
                newForm.formType = Wars.Domain.Model.Codes.Enums.FormType.SinglePage;
            }

            newForm.maxInstances = 1;
            newForm.formSchema = this.dataSourceService.createNewObjectSchema();
            newForm.formSchema.formUniqueId = newForm.uniqueIdentifier;
            newForm.securityMatrix = this.securityMatrixService.createAdvancedSecurityMatrix(false, false);
            newForm.displayOrder = this.forms.length + 1;

            var self = this;
            this.modalService.showModal({
                    templateUrl: "./app/views/modals/addFormModal.html",
                    controller: "addFormModalController",
                    size: 'lg',
                    inputs: {
                        form: newForm,
                        isReportProcess: this.processConfiguration.myProcessType.isReportProcess
                    }
                })
                .then(modal => {
                    modal.element.modal();

                    modal.close.then(result => {
                        $('.modal-backdrop')
                            .each(function() {
                                $(this).remove();
                            });

                        if (result) {
                            if (this.id) {
                                this.processConfiguration.myForms.push(newForm);
                            }
                            this.forms.push(newForm);

                            if (newForm.formType == Wars.Domain.Model.Codes.Enums.FormType.Report) {
                                let formStep = this.formService.createFormStep(newForm);
                                formStep.objectSchema = this.dataSourceService.createNewObjectSchema();
                                formStep.position = 0;

                                newForm.mySteps.push(formStep);

                                let section = this.formService.createFormSection(formStep);
                                section.formSectionDisplayType = Wars.Domain.Model.Codes.Enums.FormSectionDisplayType.Panel;
                                section.formSectionType = Wars.Domain.Model.Codes.Enums.FormSectionType.Standard;
                                section.isVisible = true;
                                section.position = 0;
                                section.objectSchema = this.dataSourceService.createNewObjectSchema();
                                section.objectSchema.uniqueIdentifier= services.UtilityService.generateGuidComb();
                                section.formSectionDisplayType = Wars.Domain.Model.Codes.Enums.FormSectionDisplayType.Panel;

                                formStep.formSections.push(section);

                                this.formService.setupFormSchema(newForm);
                            }
                            this.save();
                        } else {
                            self.dataSourceService.rejectChanges();
                        }
                    });
                });;
        }

        public save(form?) {
            if (form) services.WarsLogger.logDebug("Form Object", this.logType, form);
            this.formService.saveAllChanges();
        }

        public removeForm(form: Wars.Domain.Model.Form) {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "Form",
                form.id,
                "Form successfully deleted",
                () => this.forms.remove(form),
                "Form could not be deleted");
        }

        public configure(form: Wars.Domain.Model.Form) {
            if (this.id) {
                this.locationService.path('ProcessConfiguration/' +
                    this.processConfiguration.id +
                    '/Manage/Form/' +
                    form.id);
            } else {
                this.locationService.path('/ManageForm/' + form.id);
            }
        }

    }
}